export default __webpack_public_path__ + "static/media/ownerBannerImg.3c284566.png";